import { httpRequest } from "@/axios/axios-api";
import Vue from "vue";

export default {
  data() {
    return {
      loadingQuestionList: true,
      majorName: "", // 专业的名字
      packageExamName: "", // 题库的名字
      questionList: [],
      currentQuestionIdx: 0,
      currentQuestion: {},
      answer: "", // 字符串式的答案，如：A、B
      userAnswers: [], // 用户选的答案，这里主要是给多选题用的，记录选中的选项的序号，从0开始
      correctAnswers: [], // 当前题目的正确答案
      collectionStatus: "收藏",
      isCollected: false,
      isSubmittingAnswer: false, // 是否正在提交答案到服务器
      questionAnswerList: [], // 用户已答的所有问题的列表，长度与questionList一致，存储值固定为三个：-1：未作答；0：回答错误；1：回答正确
      questionAnswerCount: 0, // 已答题总数量
      questionAnswerCorrectCount: 0, // 已答题正确数量
      questionAnswerWrongCount: 0, // 已答题错误数量
      finishDialogVisible: false, // 是否显示结束的弹窗
      showAnswer: false, // 是否显示答案与解析
      currentQuestionTimerDuration: 0, // 每道题的答题耗时，秒
      currentQuestionTimer: null, // 每道题的答题计时器
      totalTimerDuration: 0, // 整个试卷的答题总时长
      totalTimerStr: "00:00", // 答题计时字符串
      totalTimer: null, // 整个试卷的答题总计时器
      currentPage: 1, // 当前加载的页码，从1开始
      pageSize: 100, // 每页加载的问题个数
      questionCount: 0 // 题库问题总数
    };
  },
  created: function() {
    this.loadQuestionList();
  },
  methods: {
    showPrePageQuestion() {
      if (this.currentPage <= 1) {
        this.$message.error("已经是第一页了");
      } else {
        this.currentPage--;
        this.loadQuestionList();
      }
    },
    showNextPageQuestion() {
      if (this.currentPage >= Math.ceil(this.questionCount / this.pageSize)) {
        this.$message.error("已经是最后一页了");
      } else {
        this.currentPage++;
        this.loadQuestionList();
      }
    },
    // 加载当前问题的统一方法
    async renderQuestion() {
      this.currentQuestion = this.questionList[this.currentQuestionIdx];

      this.userAnswers = [];
      this.answer = "";
      this.correctAnswers = [];
      this.collectionStatus = "收藏";
      this.isSubmittingAnswer = false;
      this.isCollected = false;
      this.showAnswer = false;

      // 计算答案部分
      this.answer = "";
      if (
        this.currentQuestion.optionList !== null &&
        this.currentQuestion.optionList !== undefined
      ) {
        this.currentQuestion.optionList.forEach(option => {
          if (option.isCorrect) {
            if (this.answer !== "") {
              this.answer += "、";
            }
            this.answer += option.sort;
            this.correctAnswers.push(option.sort);
          }
        });
      }

      // 确定是否显示答案
      if (this.questionAnswerList[this.currentQuestionIdx] !== -1) {
        this.showAnswer = true;
      }

      // 开启计时器
      this.startTimer();

      this.updateCollectionStatus();
    },
    startTimer() {
      clearInterval(this.currentQuestionTimer);
      this.currentQuestionTimerDuration = 0;
      const _this = this;
      this.currentQuestionTimer = setInterval(function() {
        _this.currentQuestionTimerDuration++;
      }, 1000);
    },
    async loadQuestionList() {
      this.loadingQuestionList = true;

      // 从收藏界面过来的情况，只加载这一个题目
      if (
        this.$route.query.eqId !== null &&
        this.$route.query.eqId !== undefined
      ) {
        const params = {
          token: this.$route.query.token // 用户的token
        };
        const res = await httpRequest(
          "/app/exam-questions/" + this.$route.query.eqId,
          "get",
          params
        );
        if (res !== null && res !== undefined && res.code === 200) {
          if (
            res.data === null ||
            res.data === undefined ||
            res.data.length === 0
          ) {
            this.$message.error("问题不存在");
            return;
          }
          this.questionList.push(res.data);
          this.questionCount = 1;
          this.majorName = "收藏题目";
          this.packageExamName = "收藏题目";

          // 初始化用户答题状态列表参数questionAnswerList
          this.questionAnswerList = new Array(this.questionList.length);
          for (
            let qalIdx = 0;
            qalIdx < this.questionAnswerList.length;
            qalIdx++
          ) {
            this.questionAnswerList[qalIdx] = -1; // 初始化为未作答状态
          }

          this.currentQuestionIdx = 0;

          this.renderQuestion();

          clearInterval(this.totalTimer);
          const _this = this;
          this.totalTimer = setInterval(function() {
            _this.totalTimerDuration++;
            _this.totalTimerStr =
              (parseInt(_this.totalTimerDuration / 60) < 10
                ? "0" + parseInt(_this.totalTimerDuration / 60)
                : parseInt(_this.totalTimerDuration / 60)) +
              ":" +
              (parseInt(_this.totalTimerDuration % 60) < 10
                ? "0" + parseInt(_this.totalTimerDuration % 60)
                : parseInt(_this.totalTimerDuration % 60));
          }, 1000);
        }
        this.loadingQuestionList = false;
        return;
      }

      const params = {
        libId: this.$route.query.libId, // 试卷id
        answerType: this.$route.query.answerType, // 答题类型
        currentPage: this.currentPage,
        pageSize: this.pageSize
      };
      const res = await httpRequest("/app/answer/questions", "get", params);
      if (res !== null && res !== undefined && res.code === 200) {
        if (
          res.data === null ||
          res.data === undefined ||
          res.data.length === 0 ||
          res.data.examQuestionList === null ||
          res.data.examQuestionList === undefined ||
          res.data.examQuestionList.length === 0
        ) {
          this.$message.error("问题列表为空");
          return;
        }
        this.questionList = res.data.examQuestionList;
        this.questionCount = res.data.totalRecord;
        this.majorName = res.data.majorName;
        this.packageExamName = res.data.packageExamName;

        // 初始化用户答题状态列表参数questionAnswerList
        this.questionAnswerList = new Array(this.questionList.length);
        for (
          let qalIdx = 0;
          qalIdx < this.questionAnswerList.length;
          qalIdx++
        ) {
          this.questionAnswerList[qalIdx] = -1; // 初始化为未作答状态
        }

        this.currentQuestionIdx = 0;

        // 获取要显示的问题
        // if (
        //   this.$route.query.eqId !== null &&
        //   this.$route.query.eqId !== undefined
        // ) {
        //   const queryEqId = parseInt(this.$route.query.eqId);
        //   if (queryEqId > 0) {
        //     // 此处是从收藏列表过来，显示指定的问题
        //     for (let qlIdx = 0; qlIdx < this.questionList.length; qlIdx++) {
        //       if (queryEqId === this.questionList[qlIdx].eqId) {
        //         this.currentQuestionIdx = qlIdx;
        //         break;
        //       }
        //     }
        //   }
        // }
        this.renderQuestion();
        // 开启总计时器
        clearInterval(this.totalTimer);
        const _this = this;
        this.totalTimer = setInterval(function() {
          _this.totalTimerDuration++;
          _this.totalTimerStr =
            (parseInt(_this.totalTimerDuration / 60) < 10
              ? "0" + parseInt(_this.totalTimerDuration / 60)
              : parseInt(_this.totalTimerDuration / 60)) +
            ":" +
            (parseInt(_this.totalTimerDuration % 60) < 10
              ? "0" + parseInt(_this.totalTimerDuration % 60)
              : parseInt(_this.totalTimerDuration % 60));
        }, 1000);
      }
      this.loadingQuestionList = false;
    },
    // 切换收藏状态
    async toggleCollectionStatus() {
      // 判断当前收藏状态，如果已经收藏则取消收藏
      if (this.isCollected) {
        const res = await httpRequest(
          "/app/answer/qust-collect-record/" + this.currentQuestion.eqId,
          "put",
          null
        );
        if (res !== null && res !== undefined && res.code === 200) {
          this.isCollected = false;
          this.collectionStatus = "收藏";
          this.$message.success("已取消收藏");
        }
      } else {
        // 直接发起请求，收藏该题目
        const data = {
          peqId: this.currentQuestion.peqId,
          eqId: this.currentQuestion.eqId
        };
        const res = await httpRequest(
          "/app/answer/qust-collect-record",
          "post",
          data
        );
        if (res !== null && res !== undefined && res.code === 200) {
          this.isCollected = true;
          this.collectionStatus = "已收藏";
          this.$message.success("已收藏");
        }
      }
    },
    // 更新收藏状态
    async updateCollectionStatus() {
      // 先请求服务器，查看该问题是否已经被收藏
      const res = await httpRequest(
        "/app/answer/is-like/" + this.currentQuestion.eqId,
        "get",
        null
      );
      if (res !== null && res !== undefined && res.code === 200) {
        this.isCollected = res.data.isLike;
      }
      this.collectionStatus = this.isCollected ? "已收藏" : "收藏";
    },
    // 点击单个选项时触发的事件
    answer_question(index) {
      // 如果已经回答过了，就不要再处理用户的点击了
      if (this.questionAnswerList[this.currentQuestionIdx] !== -1) {
        return;
      }
      // 如果当前已经选中了，则取消，如果没有选中，就选中；
      if (
        this.currentQuestion.optionList[index].isSelected === undefined ||
        this.currentQuestion.optionList[index].isSelected === null
      ) {
        // 对于新增加的属性，需要使用set方法，否则无法被Vue监听到改变
        Vue.set(this.currentQuestion.optionList[index], "isSelected", false);
      }
      if (this.currentQuestion.optionList[index].isSelected === false) {
        this.currentQuestion.optionList[index].isSelected = true;
        // 记录用户答案
        this.userAnswers.push(this.currentQuestion.optionList[index].sort);
        // 如果是单选题，要马上显示答案
        if (this.currentQuestion.type === 0) {
          // 单选题
          this.showAnswerDiv();
        }
      } else {
        // 已经选中又被点击的情况，如果是多选题就重新处理答案，如果是单选题就无视了
        if (this.currentQuestion.type === 1) {
          this.currentQuestion.optionList[index].isSelected = false;
          // 从用户答案列表中去掉当前这个选项
          for (let idx = 0; idx < this.userAnswers.length; idx++) {
            const answer = this.userAnswers[idx];
            if (answer === this.currentQuestion.optionList[index].sort) {
              this.userAnswers.splice(idx, 1); // 在下标处开始删除,删除一位
              break;
            }
          }
        }
      }
    },
    // 上一题
    previous_question() {
      // 先提交结果
      this.submitAnswer();
      if (this.currentQuestionIdx > 0) {
        this.currentQuestionIdx--;
        this.renderQuestion();
      }
    },
    // 下一题
    next_question() {
      // 先提交结果
      this.submitAnswer();
      if (this.currentQuestionIdx < this.questionList.length - 1) {
        this.currentQuestionIdx++;
        this.renderQuestion();
      } else {
        // 先判断当前是否为最后一页，如果不是，就加载下一页的问题列表
        const totalPageCount = Math.ceil(this.questionCount / this.pageSize);
        if (this.currentPage < totalPageCount) {
          this.showNextPageQuestion();
        } else {
          // 结束答卷，显示最后结果
          this.questionAnswerCount = 0; // 已答题总数量
          this.questionAnswerCorrectCount = 0; // 已答题正确数量
          this.questionAnswerWrongCount = 0; // 已答题错误数量
          this.questionAnswerList.forEach(userCurAnswer => {
            if (userCurAnswer === 0) {
              this.questionAnswerWrongCount++;
              this.questionAnswerCount++;
            } else if (userCurAnswer === 1) {
              this.questionAnswerCorrectCount++;
              this.questionAnswerCount++;
            }
          });
          // 是否显示结束的弹窗
          this.finishDialogVisible = true;
        }
      }
    },
    // 显示弹窗结果的方法
    showFinishDialog() {
      // 结束答卷，显示最后结果
      this.questionAnswerCount = 0; // 已答题总数量
      this.questionAnswerCorrectCount = 0; // 已答题正确数量
      this.questionAnswerWrongCount = 0; // 已答题错误数量
      this.questionAnswerList.forEach(userCurAnswer => {
        if (userCurAnswer === 0) {
          this.questionAnswerWrongCount++;
          this.questionAnswerCount++;
        } else if (userCurAnswer === 1) {
          this.questionAnswerCorrectCount++;
          this.questionAnswerCount++;
        }
      });
      // 是否显示结束的弹窗
      this.finishDialogVisible = true;
    },
    // 跳到指定问题
    jump2Question(index) {
      // 先提交结果
      this.submitAnswer();
      this.currentQuestionIdx = index;
      this.renderQuestion();
    },
    // 查看答案
    showAnswerDiv() {
      this.showAnswer = true;
      // 把答题记录提交到后台
      this.submitAnswer();
    },
    // 提交答案
    async submitAnswer() {
      if (this.isSubmittingAnswer) {
        return;
      }
      // 已经打过题的就不再提交了
      if (this.questionAnswerList[this.currentQuestionIdx] !== -1) {
        return;
      }
      this.isSubmittingAnswer = true;
      // 将当前问题的答案提交到服务器
      if (this.userAnswers.length > 0) {
        let userAnswerStr = "";
        this.userAnswers.forEach(answer => {
          if (userAnswerStr !== "") {
            userAnswerStr += "、";
          }
          userAnswerStr += answer;
        });
        // 判断是否是正确答案
        let isCorrect = true;
        if (this.userAnswers.length !== this.correctAnswers.length) {
          isCorrect = false;
        } else {
          for (let idx = 0; idx < this.userAnswers.length; idx++) {
            if (this.correctAnswers.indexOf(this.userAnswers[idx]) < 0) {
              isCorrect = false;
              break;
            }
          }
        }

        // 存储用户的答案是否正确的标志，标志不为-1就表示已经作答了
        this.questionAnswerList[this.currentQuestionIdx] = isCorrect ? 1 : 0;

        const data = {
          token: this.$route.query.token,
          arId: this.currentQuestion.arId,
          answerDuration: this.currentQuestionTimerDuration,
          selectOption: userAnswerStr,
          isCorrect: isCorrect
        };
        await httpRequest("/app/answer", "put", data);
      }
      this.isSubmittingAnswer = false;
    },
    finishPractice() {
      // 先提交结果
      this.submitAnswer();
      this.$router.go(-1);
    }
  }
};
